import { AppCTX } from 'types';
import { buildUserState, UserState } from 'store/state';
import { CurityAuthParams } from 'consts';
import { expirationTime, FormValues, isLogged, TokenData } from 'helpers';
import { userAction } from 'store/actions';

export function HandleUserForm(ctx: AppCTX, formValues: FormValues) {
	const { config, entityType, flowType, dispatch } = ctx;
	const { CURITY_AUTHORIZATION_URL, CURITY_CLIENT_ID, IS_EMPLOYEE_WEB } = config;
	const user = { ...buildUserState(), ...formValues, entityType, flowType, exp: expirationTime() };
	dispatch([userAction, { user }]);
	if (IS_EMPLOYEE_WEB) {
		const qs = new URLSearchParams(CurityAuthParams(CURITY_CLIENT_ID));
		window.location.href = `${CURITY_AUTHORIZATION_URL}?${qs}`;
	} else {
		AuthenticateUser(ctx, formValues, user);
	}
}

function AuthenticateUser(ctx: AppCTX, formValues: FormValues, userState: UserState) {
	const { config, dispatch, http, t } = ctx;
	const msg = t('authentication_loading_text', 'authentication');
	http.post(config.API.authenticate, formValues, msg).then((res: any) => {
		if (res?.token) {
			const tokenData = TokenData(res.token);
			if (tokenData) {
				const user = {
					email: tokenData.email ?? userState.email,
					exp: tokenData.exp,
					givenName: tokenData.given_name,
					kennitala: tokenData.sub,
					phone: tokenData.phone_number ?? userState.phone,
					token: res.token
				} as UserState;
				if (isLogged(user)) {
					dispatch([userAction, { user }]);
					const ms = (user.exp - Math.floor(Date.now() / 1000)) * 1000;
					setTimeout(() => dispatch([userAction, { user: buildUserState() }]), ms);
				}
			}
		}
	});
}
